import { AnimatePresence } from 'framer-motion';
import { useClientFeedbackContext } from '../../contexts/ClientFeedbackProvider';
import { ClientFeedback } from '../../types/feedbacks';
import FeedbackDetailsModal from '../CommonComps/Modals/FeedbackDetailsModal';

const ClientFeedbackModalSection = () => {
  // integration of context hooks here
  const {
    clientFeedback,
    showClientFeedbackModal,
    setShowClientFeedbackModal,
  } = useClientFeedbackContext();

  // rendering client feedback modal section here
  return (
    <section>
      <AnimatePresence initial={false} mode='wait' onExitComplete={() => null}>
        {showClientFeedbackModal && (
          <FeedbackDetailsModal
            feedback={clientFeedback as ClientFeedback}
            handleModalClose={() => setShowClientFeedbackModal(false)}
            isClient
          />
        )}
      </AnimatePresence>
    </section>
  );
};

export default ClientFeedbackModalSection;
